<template>
  <footer v-show="showLayout && !isMobileApp">
    <div class="footer_nav">
      <div class="header_logo d-flex justify-content-center">
        <router-link to="/login" class="logo" v-show="!isLogin">
          <img src="@/assets/img/logo_01.svg" alt="マナビス化粧品会員サイト" />
        </router-link>
        <router-link to="/" class="logo" v-show="isLogin">
          <img src="@/assets/img/logo_01.svg" alt="マナビス化粧品会員サイト" />
        </router-link>
        <!-- <button v-show="isLogin" @click="logout" id="LogOut" type="button" class="btn">
          ログアウト
        </button> -->
      </div>
    </div>
    <div class="copy">COPYRIGHT&copy;マナビス化粧品 All RIGHTS RESERVED</div>
  </footer>
</template>

<script>
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
import Device from "@/modules/Device";
let device = new Device();

export default {
  computed: {
    isMobileApp() {
      return device.isMobileApp();
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    showLayout() {
      return this.$store.state.showLayout;
    },
  },
  methods: {
    logout() {
      auth.logout();
    },
  },
};
</script>


<style scoped>
 .footer_nav .logo img {
   height: 50px;
 }
</style>
